<p>
  designhead works!
</p>



// WEBPACK FOOTER //
// ./src/app/platform/organisation/designhead/designhead.component.html